/**
 * Minifigs 2.0 - Apply torso image overlay to product media gallery items
 *
 *
 * @author Benjamin Wilson <benjamin.wilson@four.agency>
 * @author Matt Haynes <matthew.haynes@four.agency>
 * @package Joi Polloi
 */

const applyOverlayImage = (overlay, src) => {
    if (overlay.children.length > 0) return;
    const imgElement = document.createElement('img');
    imgElement.src = src;
    overlay.appendChild(imgElement);
    overlay.style.position = 'absolute';
    overlay.style.display = 'block';
};

const cartImageOverlays = () => {
    const imageOverlays = Array.from(document.querySelectorAll('.cartImageOverlay'));

    const needsApiFetch = [];
    imageOverlays.forEach((overlay) => {
        const presetUrl = overlay.dataset.overlayImage;
        if (presetUrl) {
            applyOverlayImage(overlay, presetUrl);
        } else if (overlay.dataset.itemId) {
            needsApiFetch.push(overlay);
        }
    });

    if (needsApiFetch.length === 0) return;

    const itemIds = needsApiFetch.map((overlay) => overlay.dataset.itemId);

    const getMetafield = async () => {
        try {
            const resp = await fetch('/api/2025-04/graphql.json', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/graphql',
                    'Access-Control-Origin': '*',
                    'X-Shopify-Storefront-Access-Token': 'e14901ef020f42eff2b10fbed13e6e18',
                },
                body: getParentProductIdsQuery(itemIds),
            });

            return await resp.json();
        } catch (err) {
            console.log('Fetch Error :-S', err);
        }
    };

    getMetafield().then((res) => {
        needsApiFetch.forEach((overlay) => {
            const variantInfo = res.data?.nodes.find(
                (node) => node.id === `gid://shopify/ProductVariant/${overlay.dataset.itemId}`
            );

            if (variantInfo && variantInfo.torsoOverlayValue) {
                const overlayString =
                    variantInfo.torsoOverlayValue?.value === 'Dark' ? 'Dark-Artwork' : 'Colour-Artwork';
                const overlayImg = variantInfo.product.images.edges.find((image) =>
                    image.node.url.includes(overlayString)
                );

                if (overlayImg) {
                    applyOverlayImage(overlay, overlayImg.node.url);
                }
            }
        });
    });
};

const observeCartDrawer = () => {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.attributeName === 'class') {
                cartImageOverlays();
            }
        });
    });

    observer.observe(cartDrawer, { attributes: true });
};

document.addEventListener('DOMContentLoaded', () => {
    observeCartDrawer();
});

export default cartImageOverlays;

const getParentProductIdsQuery = (variantIds) => {
    const formattedIds = variantIds.map((id) => `gid://shopify/ProductVariant/${id}`);
    return `
    {
        nodes(ids: ${JSON.stringify(formattedIds)}) {
            ... on ProductVariant {
                id
                torsoOverlayValue: metafield(
                        namespace: "custom"
                        key: "torso_overlay"
                    ) {
                        value
                    }
                product {
                    id
                    images(first: 200) {
                        edges {
                            node {
                                url
                            }
                        }
                    }
                }
            }
        }
    }`;
};
